'use strict';

var pTry = function pTry(fn) {
  for (var _len = arguments.length, arguments_ = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    arguments_[_key - 1] = arguments[_key];
  }

  return new Promise(function (resolve) {
    resolve(fn.apply(void 0, arguments_));
  });
};

module.exports = pTry; // TODO: remove this in the next major version

module.exports.default = pTry;